module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/material-ui/~/core-js/library/modules/_library.js
// module id = 147
// module chunks = 0